export enum WidgetEnum {
	EXTERNAL_APPLICATIONS = 'EXTERNAL_APPLICATIONS',
	HTML = 'HTML',
	CONTACT = 'CONTACT',
	SIMULATORS = 'SIMULATORS',
	CHART = 'CHART',
	DOCUMENT_UPLOAD = 'DOCUMENT_UPLOAD',
	DOCUMENT_LAST_UPLOADS = 'DOCUMENT_LAST_UPLOADS',
}

export enum RenderModeEnum {
	CAROUSEL = 'CAROUSEL',
	LIST = 'LIST',
}
